import { SET_PORTAL_API } from "./portal_actions";
import { START_LOADING, END_LOADING } from "./loading_actions";
import {
  TEXT_RESET_PASSWORD, TITLE_NOTIFICATION, TITLE_ERROR
} from "../../utils/constants";
import { postSetPassword } from "../../utils/api";

export const SET_PASSWORD_EDIT_CP = 'SET_PASSWORD_EDIT_CP';
export const SET_PASSWORD_EDIT_NP = 'SET_PASSWORD_EDIT_NP';
export const SET_PASSWORD_EDIT_RNP = 'SET_PASSWORD_EDIT_RNP';
export const SET_PASSWORD_CLEAR_FORM = 'SET_PASSWORD_CLEAR_FORM';



export const postSetPasswordThunk = (accessToken, refreshToken,
  data
) => {

  return (dispatch) => {
    dispatch({ type: START_LOADING });
    postSetPassword(accessToken, refreshToken, data)
      .then(data => {
        dispatch({ type: SET_PASSWORD_CLEAR_FORM });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_RESET_PASSWORD
        });
      })
      .catch(error => {
        console.log('error =', error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
